import React from 'react';

import Button, { ButtonProps } from './Button';

const CallUsButton = (props: ButtonProps) => {
  const handleClick = () => {
    window.location.href = 'tel:(866) 367-3271';
  };

  return (
    <Button {...props} onClick={handleClick}>
      Call Us at (866) 367-3271
    </Button>
  );
};

export default CallUsButton;
